exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}.sf-divider{display:var(--divider-display, block);margin:var(--divider-margin);max-width:var(--divider-max-width);width:var(--divider-width);border:var(--divider-border, var(--divider-border-style, solid) var(--divider-border-color, var(--c-light)));border-width:var(--divider-border-width, 1px)}\n", ""]);

// exports
